import * as types from '../../index';


export const pointsListAction = (data) => {
    return {
    type: types.OMNU_POINTS_LIST,
    data
    }
};

export const pointsSaveAction = (data) => {
    return {
    type: types.OMNU_POINTS_SAVE,
    data
    }
};